import { render, staticRenderFns } from "./LabToolBusinessModelCanvas.vue?vue&type=template&id=8b240da4&scoped=true&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./LabToolBusinessModelCanvas.vue?vue&type=script&lang=js&"
export * from "./LabToolBusinessModelCanvas.vue?vue&type=script&lang=js&"
import style0 from "./LabToolBusinessModelCanvas.vue?vue&type=style&index=0&id=8b240da4&scoped=true&lang=css&rel=stylesheet%2Fcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b240da4",
  null
  
)

export default component.exports